import { AppThunk } from "@/redux/RootReducer";
import { apolloClient } from "../../../../apollo-client/ApolloClient";
import { batch } from "react-redux";
import { customerRouteRedux } from "../../../product-and-price/customer-route/redux";
import { rateSheetStandardTableWrapperActions } from "../../../product-and-price/rate-sheet/redux";
import { rateSheetTableActions } from "../../../product-and-price/rate-sheet/actions";
import { cleanRatePrice } from "../../../product-and-price/rate-sheet/util/PriceCleaner";
import { transformRouteAgreementToRoutesForm } from "../../types/RoutesFormModel";
import {
  MultilegRouteAgreementRouteAgreementFetcherQuery,
  MultilegRouteAgreementRouteAgreementFetcherQueryVariables,
} from "@/gql/graphql";
import { customerRouteRouteAgreementFragment } from "../../gql/fragments/RouteAgreementPageFragment";
import { gql } from "@apollo/client";

const query = gql`
  ${customerRouteRouteAgreementFragment}
  fragment MultilegRouteAgrAgreements on MultiLegRouteAgreement {
    id
    routeAgreements {
      ...CustomerRouteRouteAgreement
    }
  }
  query MultilegRouteAgreementRouteAgreementFetcher(
    $multiLegRouteAgreementId: ID!
  ) {
    productPrice {
      multiLegRouteAgreement {
        byId(id: $multiLegRouteAgreementId) {
          ...MultilegRouteAgrAgreements
        }
      }
    }
  }
`;
export const populateMultiLegRouteAgreementRouteAgreementState =
  (multiLegRouteAgreementId: string): AppThunk =>
  async (dispatch) => {
    const r = await apolloClient.query<
      MultilegRouteAgreementRouteAgreementFetcherQuery,
      MultilegRouteAgreementRouteAgreementFetcherQueryVariables
    >({
      query,
      variables: {
        multiLegRouteAgreementId,
      },
      fetchPolicy: "network-only",
    });

    const routeAgreements =
      r.data.productPrice.multiLegRouteAgreement.byId?.routeAgreements;

    if (routeAgreements) {
      batch(() => {
        dispatch(customerRouteRedux.actions.clearAll());
        dispatch(rateSheetStandardTableWrapperActions.clearAll());

        dispatch(
          rateSheetStandardTableWrapperActions.setRouteAgreements(
            routeAgreements
          )
        );

        routeAgreements.forEach((routeAgreement) => {
          dispatch(
            rateSheetStandardTableWrapperActions.tableRows.recordAction(
              routeAgreement.id,
              rateSheetTableActions.populateWithPersistedPrices(
                routeAgreement.prices.map(cleanRatePrice)
              )
            )
          );
          dispatch(
            customerRouteRedux.actions.setRouteAgreementModel(
              routeAgreement.id,
              {
                ...transformRouteAgreementToRoutesForm(routeAgreement),
                rowVersion: routeAgreement.rowVersion,
              }
            )
          );
        });
      });
    }
  };
